import React from "react";

export enum Calculation {
    off,
    easy,
    medium,
    hard,
}
